import { IconProps } from "../../types/utils";

const CompleteIcon = ({ color, dimension, ...props }: IconProps) => (
  <svg
    width={dimension || 20}
    height={dimension || 17}
    viewBox="0 0 20 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect x="0.5" y="0.910278" width="15" height="15" stroke="#6DA588" />
    <line
      x1="4.78087"
      y1="6.58044"
      x2="8.78087"
      y2="11.5804"
      stroke="#E69394"
      stroke-width="2"
    />
    <line
      x1="7.35982"
      y1="11.4369"
      x2="19.3598"
      y2="1.43692"
      stroke="#E69394"
      stroke-width="2"
    />
  </svg>
);

export default CompleteIcon;
